/**
 * @author Jersson Stiven Morales Alza
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  'sidebar.smartstock': 'Tipos Clientes',
  'sidebar.tiposclientes': 'Tipos Clientes',
  'tiposClientes.agregarTiposClientes': 'Crear Tipos Clientes',
  'tiposClientes.modificarTiposClientes': 'Editar Tipos Clientes',
  'tiposClientes.tipoClienteId': 'Tipo Cliente Id',
  'tiposClientes.empresaId': 'Empresa Id',
  'tiposClientes.tipoClienteDescripcion': 'Tipo Cliente Descripción',
  'tiposClientes.VerTiposClientes': 'Ver Tipos Clientes',
};
